import { reactive } from "vue";
import { io } from "socket.io-client";

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: []
});

export const chatURL = process.env.VUE_APP_CHAT_URL;
// export const chatURL = "http://localhost:3000";